/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AgentImpersonationExchangeRequest model module.
 * @module model/AgentImpersonationExchangeRequest
 * @version 1.0.0
 */
class AgentImpersonationExchangeRequest {
    /**
     * Constructs a new <code>AgentImpersonationExchangeRequest</code>.
     * @alias module:model/AgentImpersonationExchangeRequest
     * @param oneTimeCode {String} 
     */
    constructor(oneTimeCode) { 
        
        AgentImpersonationExchangeRequest.initialize(this, oneTimeCode);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, oneTimeCode) { 
        obj['one_time_code'] = oneTimeCode;
    }

    /**
     * Constructs a <code>AgentImpersonationExchangeRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentImpersonationExchangeRequest} obj Optional instance to populate.
     * @return {module:model/AgentImpersonationExchangeRequest} The populated <code>AgentImpersonationExchangeRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentImpersonationExchangeRequest();

            if (data.hasOwnProperty('one_time_code')) {
                obj['one_time_code'] = ApiClient.convertToType(data['one_time_code'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentImpersonationExchangeRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentImpersonationExchangeRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of AgentImpersonationExchangeRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['one_time_code'] && !(typeof data['one_time_code'] === 'string' || data['one_time_code'] instanceof String)) {
            throw new Error("Expected the field `one_time_code` to be a primitive type in the JSON string but got " + data['one_time_code']);
        }

        return true;
    }


}

AgentImpersonationExchangeRequest.RequiredProperties = ["one_time_code"];

/**
 * @member {String} one_time_code
 */
AgentImpersonationExchangeRequest.prototype['one_time_code'] = undefined;






export default AgentImpersonationExchangeRequest;

